import { ComponentType, ReactNode } from 'react';

import { RiLinkM } from '@remixicon/react';

import {
  ItemRenderExtensionOptions,
  createItemRenderExtension,
  createItemRenderExtensions,
  useItemRenderExtensions,
} from '@spotify/confidence-core-react';
import { AttachmentFragment } from '@spotify/confidence-graphql';

export const DEFAULT_ARTIFACT_ICON = { Icon: RiLinkM, color: '#2ECC71' };

export interface ArtifactExtensionOptions
  extends ItemRenderExtensionOptions<AttachmentFragment> {
  icon?: (item: AttachmentFragment) => {
    Icon: ComponentType<{
      size?: number | string;
      className?: string;
      style?: object;
    }>;
    color: string;
  };
  label?: string;
  category?: string;
  renderHeaderActions?: (item: AttachmentFragment) => ReactNode;
  renderCard?: (item: AttachmentFragment, onClick: () => void) => ReactNode;
  renderListItem?: (
    item: AttachmentFragment,
    options: { onSelect: () => void; onDelete?: () => void },
  ) => ReactNode;
}

export const ArtifactExtensions =
  createItemRenderExtensions<ArtifactExtensionOptions>({
    id: 'artifact',
  });

export const createArtifactExtension = (options: ArtifactExtensionOptions) => {
  return createItemRenderExtension<ArtifactExtensionOptions>(options);
};

export const useArtifactExtensions = () => {
  return useItemRenderExtensions<ArtifactExtensionOptions>(ArtifactExtensions);
};
